/**
 * Page Login
 * 
 * @module page-login
 * @version 1.0.0
 * @extends HTMLElement
*/

customElements.component = 'page-login';

if (!customElements.get(customElements.component)) {

    class pageLogin extends HTMLElement {

        constructor() {

            super();

            this.addBtnForgotPasswordBehavior();
            this.checkUrlHash();
        }

        /**
         * Listen forgot password button
         * 
         * @return {undefined}
         */
        addBtnForgotPasswordBehavior() {
            let btn = this.querySelector('[data-recover-password-btn]');

            if(!btn) return;

            btn.addEventListener("click", this.showRecoverPasswordForm.bind(this));
        }

        /**
         * Show recover password form
         * 
         * @return {undefined}
         */
        showRecoverPasswordForm() {
            let recoverForm = this.querySelector('[data-recover-password-form]');
            let loginForm = this.querySelector('[data-customer-login-form]')
            if (!recoverForm) {
                return;
            }

            recoverForm.classList.add('active');
            loginForm.classList.remove('active');
        }

        /**
         * Check the current URL
         * 
         * @return {undefined}
         */
        checkUrlHash() {
            var hash = window.location.hash;
            
            if (hash === '#recover') {
                this.showRecoverPasswordForm();
            }
        }

    }

    customElements.define(customElements.component, pageLogin);
}